import { Component, OnDestroy, OnInit, computed, input, signal } from '@angular/core';
import { formatJobStatusLabel, isInProgressJobPhase } from '../../job-status-label';

@Component({
  selector: 'app-job-status-line',
  template: `
    @if (label(); as text) {
      @switch (mode()) {
        @case ('block') {
          <p [class]="klass()">
            {{ prefix() }}:
            <strong class="job-status">{{ text }}<span class="job-status__dots">{{ dots() }}</span></strong>
          </p>
        }
        @case ('inline') {
          <span>
            @if (prefix()) {
              {{ prefix() }}:
            }
            <strong class="job-status">{{ text }}<span class="job-status__dots">{{ dots() }}</span></strong>
          </span>
        }
        @case ('value') {
          <strong class="job-status">{{ text }}<span class="job-status__dots">{{ dots() }}</span></strong>
        }
      }
    }
  `,
  styles: `
    .job-status__dots {
      display: inline-block;
      min-width: 1.25em;
      text-align: left;
    }
  `,
})
export class JobStatusLineComponent implements OnInit, OnDestroy {
  readonly phase = input<string | null>(null);
  readonly prefix = input('Status');
  readonly mode = input<'block' | 'inline' | 'value'>('block');
  readonly klass = input('status');

  private readonly tick = signal(0);
  private timer?: ReturnType<typeof setInterval>;

  protected readonly label = computed(() => formatJobStatusLabel(this.phase()));
  protected readonly dots = computed(() => {
    if (!isInProgressJobPhase(this.phase())) {
      return '';
    }
    return '.'.repeat((this.tick() % 3) + 1);
  });

  ngOnInit(): void {
    this.timer = setInterval(() => this.tick.update((value) => value + 1), 450);
  }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
